export default {
  pageTitle: 'Fabrikasi Mufle',
  metaDescription: 'TEF memfabrikasi mufle industri dan komponen furnace berbahan alloy tahan suhu tinggi untuk aplikasi thermal processing.',
  sidebar: {
    title: 'Daftar Fabrikasi',
    vessel: 'Fabrikasi Vessel',
    heatExchanger: 'Fabrikasi Heat Exchanger',
    piping: 'Fabrikasi Piping',
    tower: 'Fabrikasi Tower',
    muffle: 'Fabrikasi Muffle',
    radiantTube: 'Fabrikasi Radiant Tube',
    otherEquipment: 'Fabrikasi Other Equipment',
  },
  fabricationOf: 'Fabrikasi',
  product: {
    name: 'Muffle',
    desc: 'Berikut adalah katalog pengalaman kami dalam fabrikasi Muffle dengan berbagai jenis material, tipe, dan spesifikasi.',
  },
};
